import React ,{useEffect} from "react";
import { Formik } from "formik";
import CMSFormRadioButtons from "../../../../shared/formFields/CMSFormRadioButtons";
import { Accordion } from "react-bootstrap";

const MediaGalleryFilters = ({
  screen,
  onSubmit,
  sortArray,
  parentState,
  availableYears,
  onClick,
  search,
  setSearch,
}) => {
  const handleFormatArray = (item) => {
    const array = [];
    for (let i = 0; i < item.length; i++) {
      array.push({ label: item[i], value: item[i] });
    }

    return array;
  };

  return (
    <Formik
      initialValues={{
        year: screen.year ? screen.year : "",
        sort: screen.sortedValue ? screen.sortedValue : "",
      }}
      onSubmit={async (values) => {
        onSubmit(values);
      }}
      onReset={async () => {
        parentState({
          ...screen,
          sortedValue: "",
          searchedValue: "",
          year: "",
        });
        setSearch("");
        localStorage.setItem("mediaFiltersApplied", JSON.stringify(""));
        localStorage.setItem(
          "mediaScreenValues",
          JSON.stringify({
            ...screen,
            sortedValue: "",
            searchedValue: "",
            year: "",
          })
        );
        //onClick();
      }}
    >
      {(form) => (
        <>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Choose a Year</Accordion.Header>
              <Accordion.Body>
                <div className="filterHead sort">
                  <CMSFormRadioButtons
                    name="year"
                    form={form}
                    label=""
                    options={handleFormatArray(availableYears)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="showOnMobile">
              <Accordion.Header>Sort by</Accordion.Header>
              <Accordion.Body>
                <div className="filterHead sort">
                  <CMSFormRadioButtons
                    name="sort"
                    form={form}
                    label=""
                    options={sortArray}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div className="filterHeadBottom sort">
            <a href="" className="filterApply" onClick={form.handleSubmit}>
              apply
            </a>
          </div>
          {screen.year.length > 0 || screen.searchedValue ? (
            <div className="filterHeadBottom sort">
              <a href="" className="filterApply" onClick={form.handleReset}>
                reset all filters
              </a>
            </div>
          ) : null}
        </>
      )}
    </Formik>
  );
};

export default MediaGalleryFilters;
